import type { ReactNode } from "react";
import type { ShowErrorWhen, WrappedFieldMetaProps } from "redux-form";

export type TextFieldErrorProps = {
  mapErrorCode?: (errorCode: string, isSignup?: boolean) => string | null;
  hideError?: boolean;
};

export const TextFieldHelperText = ({
  meta,
  showErrorWhen,
  hideError,
  mapErrorCode,
  helperText,
}: {
  showErrorWhen: ShowErrorWhen;
  meta: WrappedFieldMetaProps;
  helperText?: ReactNode;
} & TextFieldErrorProps) => {
  const { error, submitFailed } = meta;
  const isError = error && (meta[showErrorWhen] || submitFailed) && !hideError;
  if (!isError) {
    return helperText;
  }

  if (Array.isArray(error)) {
    return error.map((err) => (
      <span className="m0 block" key={err}>
        {mapErrorCode ? mapErrorCode(err) : err}
      </span>
    ));
  }

  return error;
};
